import { getPayCallbackService, OrderInfo, PayStatus } from "@/services/order";
import { message, Modal, Row, Spin } from "antd";
import { ReactComponent as AliIcon } from "@/assets/images/ali_pay.svg";
import { useRequest } from "ahooks";
import { AliPayId, ResponseCode } from "@/constants";
import { useEffect, useRef, useState } from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import useToken from "antd/es/theme/useToken";

export default function AliPay(props: {
  open: boolean;
  onClose: () => void;
  orderInfo?: OrderInfo;
  onSuccess: () => void;
}) {
  const { open, onClose, orderInfo, onSuccess } = props;
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const {
    data: status = PayStatus.WAIT,
    cancel,
    run: fetchStatus,
  } = useRequest(
    async (payId: string) => {
      if (status === PayStatus.DONE || status === PayStatus.CANCEL) {
        setTimeout(() => {
          onSuccess();
        }, 1000);
        cancel();
      }
      const rsp = await getPayCallbackService({
        payId: payId || "",
      });
      if (rsp.code !== ResponseCode.Success) {
        message.error(rsp.msg);
        return;
      }
      return rsp.data;
    },
    {
      pollingInterval: 1000,
      manual: true,
    }
  );

  useEffect(() => {
    if (!open) {
      cancel();
    }
  }, [open]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const cb = (e: MessageEvent) => {
      if (typeof e.data === "object" && e.data.type === AliPayId) {
        setLoading(false);
        fetchStatus(e.data.payId);
      }
    };
    window.addEventListener("message", cb);
    return () => {
      window.removeEventListener("message", cb);
    };
  }, []);

  const [, token] = useToken();

  function renderStatus(status: PayStatus) {
    switch (status) {
      case PayStatus.DONE:
        return (
          <div className="text-xxl">
            <CheckCircleFilled
              style={{ color: token.colorPrimary }}
              size={32}
              className="mr-2"
            />
            支付成功
          </div>
        );
      case PayStatus.CANCEL:
        return (
          <div>
            <div>支付取消</div>
            <a>重新获取二维码</a>
          </div>
        );
      default:
        return null;
    }
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="支付宝支付"
      footer={null}
      afterClose={() => setLoading(true)}
      destroyOnClose
      width={480}
    >
      <div className="text-center mb-1">
        <div>支付金额:</div>
        <div>
          <span className="text-base text-[#EC7057]">¥ </span>
          <span className="text-[32px] font-[DIN] text-[#EC7057]">
            {orderInfo?.amount}
          </span>

          <Spin className="mb-[28px]" spinning={loading}>
            <div className="w-[170px] h-[170px] border-none m-auto overflow-hidden mt-[28px] mb-[14px] relative">
              <iframe
                ref={iframeRef}
                src={`${location.protocol}//${location.host}/alipay?orderId=${
                  orderInfo?.orderId
                }&qrcodeSize=${170}`}
                className="w-full h-full"
                scrolling="no"
              />
              {!loading && status !== PayStatus.PAYING && (
                <div className="bg-white/90 absolute w-full h-full top-0 left-0 flex items-center justify-center">
                  {renderStatus(status)}
                </div>
              )}
            </div>
          </Spin>

          <Row
            justify="center"
            className="text-primary mb-[45px]"
            align="middle"
          >
            <AliIcon className="mr-2" />
            支付宝支付
          </Row>
        </div>
      </div>
    </Modal>
  );
}
